export function downloadFile(contentType, fileName, fileData) {
  let success = false;
  if (fileData) {
    let blob = new Blob([fileData], { type: contentType });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      let URL = window.URL || window.webkitURL;
      let downloadUrl = URL.createObjectURL(blob);

      if (fileName) {
        let a = document.createElement('a');
        if (typeof a.download === 'undefined') {
          window.location = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = fileName;
          a.click();
        }
      } else {
        window.location = downloadUrl;
      }
      URL.revokeObjectURL(downloadUrl);
    }
    success = true;
  }

  return success;
}
